<template>
  <GenericBox v-if="courseGroup && courseGroup.length || (hasUserSubscriptionAccess && !courseGroup.length)">  
    <template #header >Discussão</template>

    <InfiniteScroll
      :is-loading="isLoading"
      :is-busy="!hasCourseGroupMorePages"
      @reached="fetch"
    >
      <div class="group-box">
        <GroupCommentForm
          placeholder="Participe da discussão!"
          class="comment-reply-divisor"
          :course-id="courseId"
          :type="type"
          v-if="hasUserSubscriptionAccess"
        />

        <GroupComment
          v-for="comment in courseGroup"
          :key="comment.id"
          :comment="comment"
          class="group-comment"
        />
      </div>
    </InfiniteScroll>
  </GenericBox>  
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import GroupComment from './GroupComment'
  import GroupCommentForm from './GroupCommentForm'
  import GenericBox from '@/components/boxes/GenericBox'
  import InfiniteScroll from '@/components/layout/InfiniteScroll'

  export default {
    components: {
      GroupComment,
      InfiniteScroll,
      GroupCommentForm,
      GenericBox,
    },
    props: {
      type: { type: String, required: true }
    },

    data: () => ({
      isLoading: false
    }),

    beforeDestroy () {
      this.resetState()
    },

    computed: {
      ...mapGetters('courseGroup', ['courseGroup', 'hasCourseGroupMorePages']),

      ...mapGetters('course', ['courseModuleClass','hasCourseAccess']),

      ...mapGetters('user', ['hasUserSubscriptionAccess']),

      showComments(){
        return this.courseGroup && this.courseGroup.length > 0
      },

      courseId () {
        if(this.type == 'book') {
          return parseInt(this.$route.params.id)
        }

        return this.courseModuleClass.id
      },

      labelComments(){
        return !this.hasUserSubscriptionAccess ? 'Comentários' : 'Discussão' 
      }
    },

    methods: {
      ...mapActions('courseGroup', ['fetchCourseGroup']),

      ...mapMutations('courseGroup', ['resetState']),

      async fetch () {
        this.isLoading = true

        const data = {
          type: this.type,
          id: this.courseId
        }      

        await this.fetchCourseGroup({data})

        this.isLoading = false
      }
    },

    watch: {
      courseGroup(newValue) {       
        return newValue;       
      },

      courseModuleClass(newValue){
        this.resetState()

        const data = {
          type: this.type,
          id: newValue.id
        }      

        this.fetchCourseGroup({ data })
      }
    }
  }
</script>

<style scoped lang="scss">
  .group-box > .group-comment:not(:last-child) {
    margin-bottom: 1.875rem;
    padding-bottom: 1.875rem;
    border-bottom: 1px solid rgba(#000, .15);
  }

  .comment-reply-divisor {
    border-bottom: 2px dashed rgba(#000, .15);
    margin-bottom: 2.1875rem;
    padding-bottom: 2.1875rem;
  }
</style>